import type { RequestResult } from 'interfaces/api/client';
import { ApiManager } from 'services/api/api-manager';
import type { GreetingsApiSurface } from 'services/connectivity/greetings-api';
import type { IApiGreeting } from 'store/entities/greetings/interfaces';

/**
 * Legacy greetings adapter (skeletal).
 *
 * Exposes the same surface as `greetingsConfigurationApi` (v3.6) so sagas can
 * call either one interchangeably through `getGreetingsApi()`. In this PR the
 * adapter is a thin pass-through over `ApiManager.greetingApi` (`/v2/greetings*`)
 * because the store-level `IApiGreeting` shape still matches the v2 wire format
 * 1:1. The v3.6 <-> v2 translation is added in a follow-up PR, alongside the
 * `IApiGreeting` model flip.
 */

async function fetchAll(): Promise<RequestResult<IApiGreeting[]>> {
  return ApiManager.greetingApi.fetchAll();
}

async function fetch(id: string): Promise<RequestResult<IApiGreeting>> {
  return ApiManager.greetingApi.fetch(id);
}

async function create(greeting: IApiGreeting): Promise<RequestResult<IApiGreeting>> {
  return ApiManager.greetingApi.create(greeting);
}

async function update(greeting: Partial<IApiGreeting> & { id: number }): Promise<RequestResult<IApiGreeting>> {
  return ApiManager.greetingApi.update(greeting);
}

async function remove(greetingId: string): Promise<RequestResult<void>> {
  return ApiManager.greetingApi.remove(greetingId);
}

export const legacyGreetingsApi: GreetingsApiSurface = {
  fetchAll,
  fetch,
  create,
  update,
  remove,
};
